import { ReactNode } from 'react';

interface AuthIntroProps {
  badge: string;
  title: string;
  description?: ReactNode;
}

/**
 * The block above the card: a pill, the headline, and an optional line or two
 * of explanation. Every auth screen opens with this shape.
 */
export const AuthIntro = ({ badge, title, description }: AuthIntroProps) => (
  <div className="flex flex-col items-center gap-4 text-center">
    <span className="inline-flex items-center gap-2 rounded-full bg-auth-accent px-3 py-1 text-[11px] font-medium leading-[14px] text-auth-accent-foreground">
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-auth-accent-foreground" />
      {badge}
    </span>

    {/* DM Sans, and sized in px rather than through the scale: this project
        redefines text-4xl to 77px, which turned the headline into four lines. */}
    <h1 className="font-dm-sans text-[28px] font-bold leading-[32px] text-auth-heading sm:text-[40px] sm:leading-[44px]">
      {title}
    </h1>

    {description ? (
      <p className="text-balance text-sm leading-[22px] text-auth-body">{description}</p>
    ) : null}
  </div>
);
